// extracted by mini-css-extract-plugin
export default {"wrapper":"SharedLayout_wrapper__2B5Zf","main":"SharedLayout_main__dj9bG"};